(function () {
  'use strict';

  var NAV_ITEMS = [
    { id: 'shop', label: 'Shop', pageHref: '/collections/shop-all', children: [
      { id: 'singles', label: 'Singles', pageHref: '/collections/singles' },
      { id: 'combos', label: 'Combos', pageHref: '/collections/combos' },
      { id: 'shopall', label: 'Shop all', pageHref: '/collections/shop-all' }
    ] },
    { id: 'story', label: 'Our Story', pageHref: '/pages/our-story' },
    { id: 'blogs', label: 'Blogs', pageHref: '/blogs/news' },
    { id: 'faqs', label: 'FAQs', pageHref: '/pages/faqs' },
    { id: 'reviews', label: 'Reviews', href: '#reviews', section: '#reviews' },
    { id: 'tds', label: 'Know Your TDS', href: '#know-your-tds', section: '#know-your-tds' }
  ];

  var navObserver = null;
  var navRetries = 0;
  var NAV_MAX_RETRIES = 40;
  var navInjecting = false;
  var navReflowTimer = null;
  var navRevealTimer = null;
  var NAV_REVEAL_DELAY_MS = 700;
  var NAV_REVEAL_FALLBACK_MS = 1000;

  function getHeaderHeight() {
    var header = document.querySelector('#header-component, header-component, .header');
    if (header) return header.offsetHeight;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
  }

  function getShopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function normalizePath(path) {
    var p = path || '/';
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p || '/';
  }

  function onHomepage() {
    var path = normalizePath(location.pathname);
    var root = normalizePath(getShopRoot());
    return path === '/' || path === root;
  }

  function isContactPage() {
    return /\/pages\/contact$/.test(normalizePath(location.pathname));
  }

  function absoluteShopPath(path) {
    var root = getShopRoot();
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return root + path;
  }

  function resolveNavHref(item) {
    if (item.pageHref) return absoluteShopPath(item.pageHref);
    if (onHomepage()) return item.href;
    var root = getShopRoot();
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + item.href;
  }

  function scrollToSection(target, hash) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight() - 24;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (hash) history.pushState(null, '', hash);
    if (itemSectionFromHash(hash)) setActiveNav(itemSectionFromHash(hash));
  }

  function itemSectionFromHash(hash) {
    if (!hash) return null;
    var match = NAV_ITEMS.find(function (item) {
      return item.section === hash;
    });
    return match ? match.id : null;
  }

  function closeMobileMenuDrawer() {
    var headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      try {
        if (headerDrawer.isOpen) headerDrawer.close();
        return;
      } catch (err) {
        /* fall through to DOM reset */
      }
    }

    var details = document.querySelector(
      '#Details-menu-drawer-container, header-drawer .menu-drawer-container'
    );
    if (!details || !details.hasAttribute('open')) return;

    details.classList.remove('menu-open');
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    var panel = details.querySelector('.menu-drawer');
    if (panel) panel.classList.remove('menu-drawer--has-submenu-opened');
  }

  function isDrawerNavLink(el) {
    return !!(el && el.closest('header-drawer, .menu-drawer'));
  }

  function navigateNavItem(item, e) {
    if (item.pageHref) {
      return;
    }

    if (onHomepage()) {
      var target = document.querySelector(item.section);
      if (target) {
        if (e) e.preventDefault();
        scrollToSection(target, item.href);
        setActiveNav(item.id);
      }
      return;
    }

    if (e) e.preventDefault();
    window.location.assign(resolveNavHref(item));
  }

  function attachNavClick(a, item) {
    if (a.dataset.desalBound === 'true') return;
    a.dataset.desalBound = 'true';

    a.addEventListener('click', function (e) {
      if (isDrawerNavLink(a)) closeMobileMenuDrawer();
      navigateNavItem(item, e);
    });
  }

  function createNavLink(item, linkClass) {
    var a = document.createElement('a');
    a.href = resolveNavHref(item);
    a.className = linkClass || 'desal-nav-link menu-list__link';
    a.setAttribute('data-desal-nav-id', item.id);
    if (item.section) a.setAttribute('data-desal-section', item.section);
    a.setAttribute('data-skip-node-update', 'true');
    attachNavClick(a, item);
    return a;
  }

  function createDesktopNavItem(item) {
    var li = document.createElement('li');
    li.className = 'menu-list__list-item';
    li.setAttribute('role', 'presentation');

    var a = createNavLink(item, 'menu-list__link desal-nav-link');
    var title = document.createElement('span');
    title.className = 'menu-list__link-title';
    title.textContent = item.label;
    a.appendChild(title);
    li.appendChild(a);

    if (item.children && item.children.length) {
      li.className += ' desal-has-dd';
      a.setAttribute('aria-haspopup', 'true');
      var dd = document.createElement('div');
      dd.className = 'desal-dd';
      var ddUl = document.createElement('ul');
      ddUl.className = 'desal-dd__list list-unstyled';
      item.children.forEach(function (child) {
        var cli = document.createElement('li');
        var ca = document.createElement('a');
        ca.href = resolveNavHref(child);
        ca.className = 'menu-list__link';
        ca.setAttribute('data-skip-node-update', 'true');
        var cspan = document.createElement('span');
        cspan.className = 'menu-list__link-title';
        cspan.textContent = child.label;
        ca.appendChild(cspan);
        cli.appendChild(ca);
        ddUl.appendChild(cli);
      });
      dd.appendChild(ddUl);
      li.appendChild(dd);
    }
    return li;
  }

  function createDrawerNavItem(item) {
    var li = document.createElement('li');
    li.className = 'menu-drawer__list-item menu-drawer__list-item--flat';

    var a = createNavLink(
      item,
      'menu-drawer__menu-item menu-drawer__menu-item--mainlist focus-inset desal-nav-link'
    );
    var span = document.createElement('span');
    span.className = 'menu-drawer__menu-item-text wrap-text';
    span.textContent = item.label;
    a.appendChild(span);
    li.appendChild(a);
    return li;
  }

  function findHeaderMenuInner() {
    return document.querySelector('#header-component .header-menu__inner, .header-menu__inner');
  }

  function findDrawerMenuList() {
    return (
      document.querySelector('header-drawer .menu-drawer__navigation > ul.menu-drawer__menu') ||
      document.querySelector('.menu-drawer__navigation > ul.menu-drawer__menu')
    );
  }

  function isHeaderNavRevealed() {
    var headerMenu = document.querySelector('#header-component header-menu, header-menu');
    return headerMenu && headerMenu.hasAttribute('data-desal-nav-ready');
  }

  function hideHorizonOverflowMenu(inner) {
    if (!inner) return;
    inner.querySelectorAll('overflow-list').forEach(function (el) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    });
    inner.querySelectorAll('nav.menu-list').forEach(function (el) {
      if (!el.classList.contains('desal-header-nav')) {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function revealHeaderNav() {
    var headerMenu = document.querySelector('#header-component header-menu, header-menu');
    if (!headerMenu) {
      navInjecting = false;
      return;
    }

    if (headerMenu.hasAttribute('data-desal-nav-ready')) {
      navInjecting = false;
      return;
    }

    if (navRevealTimer) clearTimeout(navRevealTimer);

    navRevealTimer = setTimeout(function () {
      headerMenu.setAttribute('data-desal-nav-ready', 'true');
      headerMenu.classList.add('desal-header-nav--revealed');
      navInjecting = false;
      setActiveForCurrentPage();
      if (onHomepage()) initScrollSpy();
    }, NAV_REVEAL_DELAY_MS);
  }

  /** Static desktop nav — bypasses Horizon overflow-list (no More, Reviews always visible) */
  function mountStaticDesktopNav() {
    var inner = findHeaderMenuInner();
    if (!inner) return false;

    hideHorizonOverflowMenu(inner);

    var existing = inner.querySelector('.desal-header-nav');
    if (existing && existing.querySelectorAll('.desal-nav-link').length >= NAV_ITEMS.length) {
      if (isHeaderNavRevealed()) return true;
      revealHeaderNav();
      return true;
    }

    if (existing) existing.remove();

    navInjecting = true;

    var nav = document.createElement('nav');
    nav.className = 'desal-header-nav menu-list';
    nav.setAttribute('aria-label', 'Main navigation');

    var ul = document.createElement('ul');
    ul.className = 'desal-header-nav__list list-unstyled';
    ul.setAttribute('role', 'list');

    NAV_ITEMS.forEach(function (item) {
      ul.appendChild(createDesktopNavItem(item));
    });

    nav.appendChild(ul);
    inner.appendChild(nav);
    hideHorizonOverflowMenu(inner);

    revealHeaderNav();
    return true;
  }

  function fillDrawerNav(ul) {
    if (!ul) return false;
    if (ul.dataset.desalNavReady === 'true') return true;

    navInjecting = true;
    ul.innerHTML = '';
    NAV_ITEMS.forEach(function (item) {
      if (item.children && item.children.length) {
        item.children.forEach(function (child) {
          ul.appendChild(createDrawerNavItem(child));
        });
      } else {
        ul.appendChild(createDrawerNavItem(item));
      }
    });
    ul.dataset.desalNavReady = 'true';
    navInjecting = false;
    return true;
  }

  function hasDesktopNav() {
    var nav = document.querySelector('.desal-header-nav');
    return nav && nav.querySelectorAll('.desal-nav-link').length >= NAV_ITEMS.length;
  }

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function hasDesalNav() {
    if (!hasDesktopNav()) return false;
    if (isDesktopViewport()) return true;
    var drawer = findDrawerMenuList();
    if (!drawer) return true;
    return drawer.querySelectorAll('.desal-nav-link').length >= NAV_ITEMS.length;
  }

  function forceRevealIfNeeded() {
    if (isHeaderNavRevealed() || !hasDesktopNav()) return;
    var headerMenu = document.querySelector('#header-component header-menu, header-menu');
    if (!headerMenu) return;
    headerMenu.setAttribute('data-desal-nav-ready', 'true');
    headerMenu.classList.add('desal-header-nav--revealed');
    navInjecting = false;
    setActiveForCurrentPage();
    if (onHomepage()) initScrollSpy();
  }

  function setActiveNav(activeId) {
    document.querySelectorAll('.desal-nav-link').forEach(function (a) {
      var isActive = a.getAttribute('data-desal-nav-id') === activeId;
      a.classList.toggle('desal-nav-link--active', isActive);
      a.classList.toggle('menu-list__link--active', isActive);
      if (isActive) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  function clearNavActive() {
    document.querySelectorAll('.desal-nav-link').forEach(function (a) {
      a.classList.remove('desal-nav-link--active', 'menu-list__link--active');
      a.removeAttribute('aria-current');
    });
  }

  function setActiveFromHash() {
    if (!onHomepage()) return;
    var hash = location.hash || '#home';
    var target = document.querySelector(hash);
    var id = itemSectionFromHash(hash) || (target ? 'home' : null);
    if (id) setActiveNav(id);
    else setActiveNav('home');
  }

  function setActiveForCurrentPage() {
    if (onHomepage()) {
      setActiveFromHash();
      return;
    }
    clearNavActive();
    if (isContactPage()) setActiveNav('contact');
  }

  var scrollSpyObserver = null;

  function initScrollSpy() {
    if (!onHomepage()) return;
    if (scrollSpyObserver) scrollSpyObserver.disconnect();

    var sections = NAV_ITEMS.filter(function (item) {
      return item.section && !item.pageHref;
    })
      .map(function (item) {
        return { id: item.id, el: document.querySelector(item.section) };
      })
      .filter(function (row) {
        return row.el;
      });

    if (!sections.length) return;

    scrollSpyObserver = new IntersectionObserver(
      function (entries) {
        var visible = entries.filter(function (e) {
          return e.isIntersecting;
        });
        if (!visible.length) return;
        visible.sort(function (a, b) {
          return b.intersectionRatio - a.intersectionRatio;
        });
        var id = sections.find(function (row) {
          return row.el === visible[0].target;
        });
        if (id) setActiveNav(id.id);
      },
      { rootMargin: '-' + (getHeaderHeight() + 40) + 'px 0px -55% 0px', threshold: [0.12, 0.25, 0.4] }
    );

    sections.forEach(function (row) {
      scrollSpyObserver.observe(row.el);
    });
  }

  function initNav() {
    var mobileList = findDrawerMenuList();
    var desktopReady = mountStaticDesktopNav();
    var mobileReady = !mobileList || fillDrawerNav(mobileList);

    return desktopReady && mobileReady && hasDesalNav();
  }

  function scheduleNavInit() {
    if (navInjecting) return;
    if (initNav()) {
      return;
    }
    if (navRetries++ < NAV_MAX_RETRIES) {
      setTimeout(scheduleNavInit, 250);
    }
  }

  function watchHeaderMenu() {
    var inner = document.querySelector('.header-menu__inner');
    if (!inner || navObserver) return;

    navObserver = new MutationObserver(function () {
      if (navInjecting || hasDesktopNav()) return;
      clearTimeout(navReflowTimer);
      navReflowTimer = setTimeout(function () {
        if (!navInjecting && !hasDesktopNav()) {
          navRetries = 0;
          scheduleNavInit();
        }
      }, 80);
    });
    navObserver.observe(inner, { childList: true, subtree: true });

    var drawer = document.querySelector('header-drawer');
    if (drawer) {
      navObserver.observe(drawer, { childList: true, subtree: true });
    }
  }

  function handleHomepageHashOnLoad() {
    if (!onHomepage() || !location.hash) return;
    var target = document.querySelector(location.hash);
    if (!target) return;
    window.requestAnimationFrame(function () {
      scrollToSection(target, location.hash);
    });
  }

  function resetDesalProductQtyUI() {
    document.querySelectorAll('.desal-atc-wrap').forEach(function (wrap) {
      var atcBtn = wrap.querySelector('.desal-atc-btn');
      var qtyCtrl = wrap.querySelector('.desal-qty-ctrl');
      var qtyNum = wrap.querySelector('.desal-qty-num');
      if (!atcBtn || !qtyCtrl) return;
      if (atcBtn.disabled || atcBtn.classList.contains('desal-btn--soldout')) return; // leave "Sold out" alone
      qtyCtrl.style.display = 'none';
      atcBtn.style.display = '';
      atcBtn.style.background = '#1C1C1C';
      atcBtn.textContent = 'Add to Cart';
      atcBtn.classList.remove('desal-adding');
      if (qtyNum) qtyNum.textContent = '1';
    });
  }

  function syncDesalProductQtyFromCart() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.item_count) {
          resetDesalProductQtyUI();
          return;
        }
        document.querySelectorAll('.desal-atc-wrap').forEach(function (wrap) {
          var variantId = wrap.getAttribute('data-variant');
          var line = cart.items.find(function (it) {
            return String(it.variant_id) === String(variantId);
          });
          var atcBtn = wrap.querySelector('.desal-atc-btn');
          var qtyCtrl = wrap.querySelector('.desal-qty-ctrl');
          var qtyNum = wrap.querySelector('.desal-qty-num');
          if (!atcBtn || !qtyCtrl) return;
          if (atcBtn.disabled || atcBtn.classList.contains('desal-btn--soldout')) return; // leave "Sold out" alone
          if (line && line.quantity > 0) {
            atcBtn.style.display = 'none';
            qtyCtrl.style.display = 'flex';
            if (qtyNum) qtyNum.textContent = line.quantity;
          } else {
            qtyCtrl.style.display = 'none';
            atcBtn.style.display = '';
            atcBtn.textContent = 'Add to Cart';
            atcBtn.style.background = '#1C1C1C';
          }
        });
      })
      .catch(function () {});
  }

  document.addEventListener('cart:update', function (e) {
    var cart = e.detail && e.detail.resource;
    if (cart && cart.item_count === 0) resetDesalProductQtyUI();
    else syncDesalProductQtyFromCart();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      if (navRevealTimer) clearTimeout(navRevealTimer);
      var headerMenu = document.querySelector('#header-component header-menu, header-menu');
      if (headerMenu) {
        headerMenu.removeAttribute('data-desal-nav-ready');
        headerMenu.classList.remove('desal-header-nav--revealed');
      }
    }
    navRetries = 0;
    scheduleNavInit();
    handleHomepageHashOnLoad();
    syncDesalProductQtyFromCart();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncDesalProductQtyFromCart();
  });

  window.addEventListener('hashchange', function () {
    if (onHomepage()) setActiveFromHash();
  });

  document.addEventListener('DOMContentLoaded', function () {
    watchHeaderMenu();
    scheduleNavInit();
    handleHomepageHashOnLoad();
    syncDesalProductQtyFromCart();

    setTimeout(forceRevealIfNeeded, NAV_REVEAL_FALLBACK_MS);

    if (customElements && customElements.whenDefined) {
      customElements.whenDefined('header-menu').then(scheduleNavInit);
    }

    window.addEventListener('load', function () {
      scheduleNavInit();
      handleHomepageHashOnLoad();
      if (!isHeaderNavRevealed() && hasDesktopNav()) revealHeaderNav();
    });
  });
})();
